<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <p-skeleton width="10rem" height="1.5rem" class="mb-2" />
        <p-skeleton width="16rem" height="0.875rem" />
      </div>
      <div class="flex-1 min-h-0 overflow-auto p-4 flex flex-col gap-3">
        @for (row of skeletonRows; track row) {
          <div class="flex items-center gap-3">
            <p-skeleton shape="circle" size="2rem" />
            <p-skeleton width="8rem" height="0.875rem" />
            <p-skeleton width="12rem" height="0.875rem" />
            <p-skeleton width="5rem" height="1.25rem" />
          </div>
        }
      </div>
    </div>
  }

  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <mat-icon class="text-red-600 mr-2">error</mat-icon>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button type="button" (click)="load()" class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
              <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                <mat-icon>handshake</mat-icon>
              </span>
              Mandatos
            </h2>
            <p class="text-sm text-slate-500 mt-1">Mandatos para cobrar bajo demanda a la tarjeta que el cliente autorizó, dentro de sus límites.</p>
          </div>
          <div class="w-full sm:w-auto flex flex-wrap items-center justify-end gap-2">
            <p-button
              label="Actualizar"
              icon="pi pi-refresh"
              severity="secondary"
              size="small"
              [rounded]="true"
              [loading]="loading()"
              (onClick)="load()" />
            <a routerLink="/mit-mandates/nuevo" class="inline-block" appDisableUnless="MIT_MANDATE_WRITE">
              <p-button label="Nuevo mandato" icon="pi pi-plus" severity="primary" size="small" appDisableUnless="MIT_MANDATE_WRITE" />
            </a>
          </div>
        </div>
      </div>

      <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
        <div class="grid grid-cols-2 xl:flex xl:flex-wrap xl:items-end gap-2">
          <p-floatlabel class="w-full min-w-0 col-span-2 sm:col-span-1 xl:w-56" variant="on">
            <input pInputText id="mitMandateQ" formControlName="q" class="w-full p-inputtext-sm" autocomplete="off" />
            <label for="mitMandateQ">Buscar</label>
          </p-floatlabel>
          <p-floatlabel class="w-full min-w-0 xl:w-48" variant="on">
            <p-select
              formControlName="status"
              inputId="mitMandateStatus"
              [options]="statusOptions"
              optionLabel="label"
              optionValue="value"
              size="small"
              [showClear]="true"
              class="w-full" />
            <label for="mitMandateStatus">Estado</label>
          </p-floatlabel>
          <div class="min-w-0 col-span-2 sm:col-span-1 xl:flex-1 xl:min-w-48">
            <p-floatlabel class="w-full" variant="on">
              <p-autocomplete
                inputId="mitMandateCustomer"
                formControlName="customer"
                [suggestions]="customerOptions()"
                (completeMethod)="onCustomerSearch($event)"
                (onSelect)="applyFilters()"
                (onClear)="applyFilters()"
                optionLabel="displayLabel"
                [minLength]="3"
                [showClear]="true"
                size="small"
                fluid
                appendTo="body">
                <ng-template #item let-customer>
                  <div class="flex flex-col py-0.5">
                    <span class="text-sm font-medium text-slate-900 leading-snug">{{ customer.comercialName || customer.legalName }}</span>
                    <span class="text-xs text-slate-400 leading-snug">{{ customer.taxId }}</span>
                  </div>
                </ng-template>
              </p-autocomplete>
              <label for="mitMandateCustomer">Cliente</label>
            </p-floatlabel>
          </div>
          <p-floatlabel class="w-full min-w-0 xl:w-40" variant="on">
            <input pInputText id="mitMandateRef" formControlName="externalReference" class="w-full p-inputtext-sm" autocomplete="off" />
            <label for="mitMandateRef">Referencia</label>
          </p-floatlabel>
          <p-floatlabel class="w-full min-w-0 col-span-2 sm:col-span-1 xl:w-64" variant="on">
            <p-datepicker
              inputId="mitMandateCreatedAt"
              formControlName="createdAtRange"
              selectionMode="range"
              [readonlyInput]="true"
              dateFormat="dd/mm/yy"
              showIcon
              iconDisplay="input"
              [showClear]="true"
              size="small"
              appendTo="body"
              class="w-full" />
            <label for="mitMandateCreatedAt">Rango F. alta</label>
          </p-floatlabel>
          @if (hasActiveFilters()) {
            <div class="flex items-end">
              <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" severity="secondary" type="button"
                (onClick)="clearFilters()" ariaLabel="Limpiar filtros" />
            </div>
          }
        </div>
      </div>

      <div class="flex-1 min-h-0 overflow-hidden">
        <p-table
          [value]="mandates()"
          dataKey="id"
          [lazy]="true"
          [scrollable]="true"
          scrollHeight="flex"
          [totalRecords]="totalItems()"
          [first]="currentPage() * pageSize()"
          [rows]="pageSize()"
          [rowsPerPageOptions]="pageSizeOptions"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} mandatos"
          [loading]="loading()"
          [paginator]="true"
          sortMode="single"
          [sortField]="sortField()"
          [sortOrder]="sortOrder()"
          (onLazyLoad)="onLazyLoad($event)"
          styleClass="mit-table p-datatable-striped p-datatable-sm"
          [rowHover]="true"
          paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !items-center !justify-between">
          <ng-template pTemplate="paginatorleft">
            <span
              class="inline-flex"
              [pTooltip]="exportButtonTooltip"
              tooltipPosition="top"
              appendTo="body">
              <p-button
                label="Exportar CSV"
                icon="pi pi-download"
                severity="secondary"
                size="small"
                [rounded]="true"
                [loading]="exporting()"
                [disabled]="!canExportMandates || exporting() || totalItems() === 0"
                (onClick)="exportCsv()" />
            </span>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="!px-2" pSortableColumn="number">Folio <p-sortIcon field="number" /></th>
              <th class="!px-2">Cliente</th>
              <th class="!px-2 hidden lg:table-cell">Propósito</th>
              <th class="!px-2" pSortableColumn="status">Estado <p-sortIcon field="status" /></th>
              <th class="!px-2 hidden md:table-cell">Tarjeta</th>
              <th class="!px-2 !text-right hidden sm:table-cell">Máx. por cobro</th>
              <th class="!px-2 !text-right">Máx. mensual</th>
              <th class="!px-2 !text-center hidden md:table-cell mit-col-validity">Vigencia</th>
              <th class="!px-2 !text-center hidden sm:table-cell" pSortableColumn="createdAt">F. alta <p-sortIcon field="createdAt" /></th>
              <th class="!px-2 !text-right">Acciones</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-mandate>
            <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors" (click)="openDetails(mandate)">
              <td class="!px-2 !py-2">
                <div class="flex items-center gap-2">
                  <div [class]="statusIconClasses(mandate.status)">
                    <mat-icon class="!text-base !w-4 !h-4 !leading-4">handshake</mat-icon>
                  </div>
                  <span class="text-sm font-medium text-slate-900">{{ mandate.number || '—' }}</span>
                </div>
              </td>
              <td class="!px-2 !py-2 max-w-[12rem]">
                <div class="text-sm text-slate-900 truncate">{{ mandate.customerName || '—' }}</div>
                <div class="text-xs text-slate-500 truncate">{{ mandate.customerEmail || '' }}</div>
              </td>
              <td class="!px-2 !py-2 hidden lg:table-cell max-w-[14rem]">
                <div class="text-sm text-slate-700 truncate">{{ mandate.purpose || '—' }}</div>
              </td>
              <td class="!px-2 !py-2 !whitespace-nowrap">
                <p-tag class="!text-xs" [severity]="statusSeverity(mandate.status)" [value]="statusLabel(mandate.status)" />
              </td>
              <td class="!px-2 !py-2 hidden md:table-cell !whitespace-nowrap text-sm text-slate-700">
                @if (mandate.card?.lastDigits) {
                  {{ mandate.card.brand || 'Tarjeta' }} •••• {{ mandate.card.lastDigits }}
                } @else {
                  <span class="text-slate-400">Sin tarjeta</span>
                }
              </td>
              <td class="!px-2 !py-2 hidden sm:table-cell !text-right !whitespace-nowrap text-sm text-slate-900">
                {{ mandate.limits?.maxAmountPerTransaction | currency:(mandate.currencyCode || 'MXN'):'symbol-narrow':'1.2-2' }}
              </td>
              <td class="!px-2 !py-2 !text-right !whitespace-nowrap text-sm text-slate-900">
                {{ mandate.limits?.maxAmountPerMonth | currency:(mandate.currencyCode || 'MXN'):'symbol-narrow':'1.2-2' }}
              </td>
              <td class="!px-2 !py-2 hidden md:table-cell !whitespace-nowrap mit-col-validity">
                @if (mandateValidity(mandate); as validity) {
                  <div class="flex w-full min-w-0 flex-col gap-1">
                    <div class="flex items-center justify-between gap-1.5 text-[11px]" [class.text-slate-500]="!validity.expired" [class.text-red-600]="validity.expired">
                      <span pTooltip="Inicio de vigencia" tooltipPosition="top">{{ validity.start | date:'dd/MM/yyyy' }}</span>
                      <span class="inline-flex items-center gap-1" [class.font-medium]="validity.expired">
                        @if (validity.end) {
                          <span pTooltip="Fin de vigencia" tooltipPosition="top">{{ validity.end | date:'dd/MM/yyyy' }}</span>
                        } @else {
                          <span>Sin fin</span>
                        }
                        @if (validity.expired) {
                          <i class="pi pi-exclamation-circle text-xs" [pTooltip]="validity.remainingLabel" tooltipPosition="top"></i>
                        }
                      </span>
                    </div>
                    <div class="relative h-3 w-full">
                      <div
                        class="absolute inset-x-0 top-1/2 h-1.5 -translate-y-1/2 overflow-hidden rounded-full bg-slate-200"
                        role="progressbar"
                        [attr.aria-valuenow]="validity.percent"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        [pTooltip]="validity.remainingLabel"
                        tooltipPosition="top"
                      >
                        <div class="h-full rounded-full transition-all" [class]="validity.barClass" [style.width.%]="validity.percent"></div>
                      </div>
                    </div>
                  </div>
                } @else {
                  <span class="text-sm text-slate-400">—</span>
                }
              </td>
              <td class="!px-2 !py-2 hidden sm:table-cell !text-center !whitespace-nowrap">
                <div class="text-sm text-slate-600">{{ mandate.createdAt | date:'dd/MM/yyyy' }}</div>
                <div class="text-[11px] text-slate-400 mt-0.5">{{ mandate.createdAt | date:'h:mm a' }}</div>
              </td>
              <td class="!px-2 !py-2 !text-right">
                <p-button icon="pi pi-ellipsis-v" [rounded]="true" [text]="true" severity="secondary"
                  ariaLabel="Acciones" (onClick)="openRowMenu($event, mandate)" />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10" class="!px-2 !py-12 !text-center !text-slate-500">
                No se encontraron mandatos con los filtros aplicados.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</div>
</div>

<p-menu #rowMenu [model]="rowMenuItems()" [popup]="true" appendTo="body" />

<p-drawer
  [visible]="isDetailsOpen()"
  position="right"
  (visibleChange)="onDrawerVisibleChange($event)"
  styleClass="mit-mandate-details-drawer !w-[800px]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full gap-3">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
          <mat-icon class="!text-xl !w-5 !h-5 !leading-5">handshake</mat-icon>
        </span>
        <div class="min-w-0">
          <h3 class="text-lg font-semibold text-slate-900">Detalle del mandato</h3>
          @if (selectedMandate()?.number) {
            <p class="text-xs text-slate-500">{{ selectedMandate()?.number }}</p>
          }
        </div>
      </div>
      @if (selectedMandate() && !detailsLoading()) {
        <button
          type="button"
          class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
          (click)="openFromDrawer()">
          <i class="pi pi-external-link text-sm"></i>
          Gestionar
        </button>
      }
    </div>
  </ng-template>
  @if (detailsLoading()) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
      <p class="text-sm text-slate-600">Cargando mandato...</p>
    </div>
  } @else if (selectedMandate()) {
    <app-mit-mandate-summary [mandate]="selectedMandate()!" />
  }
</p-drawer>

<app-mit-mandate-status-dialog
  [mandate]="statusMandate()"
  [action]="statusAction()"
  (closed)="closeStatus()"
  (changed)="onStatusChanged($event)" />
